import type { Contact } from '@newmoon-org/types';

export interface CustomerContactsLoader {
  get: (id: string) => Promise<{ contacts?: Contact[] } | null | undefined>;
}

export async function loadCustomerContacts(
  customerId: string | null | undefined,
  billingContact: Contact | null | undefined,
  customerService: CustomerContactsLoader
): Promise<Contact[]> {
  if (!customerId) return [];
  const customer = await customerService.get(customerId);
  const contacts = customer?.contacts ?? [];
  if (billingContact?.id && !contacts.some(c => c.id === billingContact.id)) {
    return [...contacts, billingContact];
  }
  return contacts;
}

export function reconcileBillingContact(
  contacts: Contact[] | null | undefined,
  billingContact: Contact | null | undefined
): Contact | undefined {
  const selectedId = billingContact?.id;
  if (!selectedId || !contacts?.length) return undefined;
  const live = contacts.find(c => c.id === selectedId);
  if (live && live !== billingContact) return live;
  return undefined;
}
